import { render, staticRenderFns } from "./ModuleStatisticDataExport.vue?vue&type=template&id=48dd5343"
import script from "./ModuleStatisticDataExport.vue?vue&type=script&lang=js"
export * from "./ModuleStatisticDataExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports